const CAROUSEL_ITEMS = [
  {
    title: '2026暑期档 · 热门大片合集',
    desc: '暑期档热映影片一网打尽，从动作科幻到合家欢动画，今夏必看片单已就位。',
    tag: '专题推荐',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20evening%20scene%20with%20warm%20golden%20sunlight%20streaming%20through%20palm%20trees%2C%20outdoor%20movie%20screen%20silhouette%20in%20distance%2C%20vibrant%20orange%20and%20pink%20sunset%20sky%2C%20dreamy%20atmospheric%20lighting%2C%20nostalgic%20film%20aesthetic%2C%20wide%20cinematic%20composition%2C%20no%20text%20no%20logos&width=1200&height=600&seq=carousel-01-v1&orientation=landscape',
  },
  {
    title: '国产科幻 · 崛起之路',
    desc: '从流浪地球到封神系列，中国科幻与奇幻电影正在书写全新篇章，精选国产视效大片。',
    tag: '深度策划',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20cityscape%20with%20traditional%20Chinese%20architectural%20elements%20blending%20sci-fi%20and%20ancient%20aesthetics%2C%20floating%20lanterns%20and%20holographic%20displays%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20epic%20cinematic%20wide%20shot%2C%20atmospheric%20mist%2C%20no%20text%20no%20logos&width=1200&height=600&seq=carousel-02-v1&orientation=landscape',
  },
  {
    title: '诺兰电影全集 · 烧脑盛宴',
    desc: '收录克里斯托弗·诺兰导演全部作品，从记忆碎片到奥本海默，开启你的烧脑之旅。',
    tag: '导演专题',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20patterns%20with%20clock%20face%20fragments%20and%20film%20reel%20elements%2C%20dark%20sophisticated%20mood%2C%20deep%20navy%20and%20warm%20brass%20color%20palette%2C%20minimalist%20cinematic%20composition%2C%20intellectual%20art%20film%20aesthetic%2C%20clean%20design%2C%20no%20text%20no%20logos&width=1200&height=600&seq=carousel-03-v1&orientation=landscape',
  },
  {
    title: '经典重温 · 豆瓣高分百部',
    desc: '精选豆瓣评分8分以上的百部经典电影，从肖申克的救赎到千与千寻，值得反复品味。',
    tag: '精选合集',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20casting%20warm%20light%20in%20a%20dark%20room%20with%20floating%20dust%20particles%2C%20old%20film%20reels%20stacked%20nearby%2C%20nostalgic%20golden%20hour%20glow%2C%20warm%20sepia%20and%20amber%20tones%2C%20classic%20cinema%20atmosphere%2C%20timeless%20elegance%2C%20no%20text%20no%20logos&width=1200&height=600&seq=carousel-04-v1&orientation=landscape',
  },
  {
    title: '动画世界 · 全家观影指南',
    desc: '从皮克斯到吉卜力再到国漫崛起，为你和你的家人精选高品质动画电影合集。',
    tag: '家庭影院',
    img: 'https://readdy.ai/api/search-image?query=Whimsical%20colorful%20abstract%20landscape%20with%20floating%20islands%20and%20soft%20cotton%20candy%20clouds%2C%20warm%20pastel%20color%20palette%2C%20magical%20atmosphere%2C%20playful%20and%20dreamy%20animation%20style%20aesthetic%2C%20wide%20scenic%20composition%2C%20gentle%20gradient%20sky%2C%20no%20text%20no%20logos&width=1200&height=600&seq=carousel-05-v1&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            焦点推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            精选专题策划，发现更多好电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="relative group rounded-lg overflow-hidden cursor-pointer h-[240px] md:h-[280px]"
            >
              <img
                src={item.img}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500/90 text-background-50 mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-background-50 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-background-50/80 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}